import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { ToggleButton } from "components/buttons";
import { BaseButton, SECONDARY } from "components/buttons/BaseButton";
import { loadExperiments, setExperiments } from "utils/storage";
import "./ExperimentsPage.scss";

export const ExperimentsPage = () => {
  const [formState, setFormState] = useState<any>({
    hls: false
  });

  const handleChangeValue = (name: string): void => {
    setFormState({
      ...formState,
      [name]: !formState[name]
    });
  };

  const handleSubmit = (e: React.FormEvent): void => {
    e.preventDefault();
    setExperiments(formState);
    toast.success("Experiments settings updated, please reload the page.");
  };

  const handleReset = (): void => {
    const defaultState = { hls: false };
    setFormState(defaultState);
    setExperiments(null);
    toast.success("Experiments reset to default state (randomly assigned).");
  };

  useEffect(() => {
    const values = loadExperiments();

    if (values) {
      setFormState(values);
    }
  }, []);

  return (
    <div className="ExperimentsPage">
      <h2>Experimental features</h2>
      <form onSubmit={handleSubmit}>
        <div className="ToggleWrap">
          <ToggleButton
            checked={formState.hls}
            onChange={() => handleChangeValue("hls")}
          />
          <span>Enable HLS (HTTP Live Streaming)</span>
        </div>
        <div className="ButtonsWrap">
          <BaseButton type="submit">Save</BaseButton>
          <BaseButton type="button" variant={SECONDARY} onClick={handleReset}>
            Reset
          </BaseButton>
        </div>
      </form>
    </div>
  );
};
